import { render, staticRenderFns } from "./PasswordExpired.vue?vue&type=template&id=c6de9906&scoped=true"
import script from "./PasswordExpired.vue?vue&type=script&lang=js"
export * from "./PasswordExpired.vue?vue&type=script&lang=js"
import style0 from "./PasswordExpired.vue?vue&type=style&index=0&id=c6de9906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6de9906",
  null
  
)

export default component.exports